import styled from 'styled-components';
import { useState } from 'react';
import { EspAccountWithCustomMTAConfig } from 'modules/graphql';
import { BUTTON_SIZES } from 'ui/button';
import {
  ARROW_DIRECTION_DOWN,
  CollapsibleContent,
  CollapsibleContentArrow,
} from 'ui/collapsibleContent';
import { mockCustomMtaMobileApps } from '../../../mockData';
import { DestinationOverflowMenu } from './DestinationOverflowMenu';
import {
  Wrapper,
  AccountDetails,
  AccountName,
  Main,
  LeftContent,
  RightContent,
  SectionHeading,
  ArrowButton,
} from '../AccountsSection.styled';
import { ApplicationRow } from './ApplicationRow';

const Rows = styled.div`
  display: grid;
  gap: 16px;
`;

export const CustomPushDestination = ({
  espAccount,
}: {
  espAccount: EspAccountWithCustomMTAConfig;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Wrapper>
      <Main>
        <LeftContent>
          <AccountName>{espAccount.customMTAConfig.name}</AccountName>
          <AccountDetails>ID {espAccount.id}</AccountDetails>
        </LeftContent>
        <RightContent>
          {mockCustomMtaMobileApps.length > 0 && (
            <>
              <ArrowButton onClick={() => setIsExpanded(!isExpanded)} size={BUTTON_SIZES.SMALL}>
                <span>{`${mockCustomMtaMobileApps.length} applications`}</span>
                <CollapsibleContentArrow
                  isCollapsed={!isExpanded}
                  arrowStart={ARROW_DIRECTION_DOWN}
                  arrowEnd={180}
                  width={16}
                  height={16}
                />
              </ArrowButton>
              <DestinationOverflowMenu />
            </>
          )}
        </RightContent>
      </Main>
      {mockCustomMtaMobileApps.length > 0 && (
        <CollapsibleContent isCollapsed={!isExpanded}>
          <SectionHeading>Applications</SectionHeading>
          <Rows>
            {mockCustomMtaMobileApps.map((customMtaMobileApp) => (
              <ApplicationRow key={customMtaMobileApp.id} customMtaMobileApp={customMtaMobileApp} />
            ))}
          </Rows>
        </CollapsibleContent>
      )}
    </Wrapper>
  );
};
